var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "clearfix"]
var hoisted2 = ["class", "fa fa-key"]
var hoisted3 = ["style", "color: red"]
var hoisted4 = ["class", "text-muted small"]
var __target

module.exports = function description (model, root) {
  elementOpen("ul")
    __target = model.items
    if (__target) {
      ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
        var key = $value
        var $key = "f7461589-dd39-4b15-b9eb-d786f1bc2673_" + $item
        elementOpen("li", $key)
          var isExpanded = root.isExpanded(key)
          elementOpen("div", "55669453-1f40-4774-ba4d-a92c568a13ed_" + $key, hoisted1)
            if (!key.isNested) {
              elementOpen("i", "efc58b84-e047-4229-8ed8-838f89011365_" + $key, hoisted2)
              elementClose("i")
            }
            if (key.isNested) {
              elementOpen("i", null, null, "class", isExpanded ? 'fa fa-folder-open-o' : 'fa fa-folder-o', "onclick", function ($event) {
                var $element = this;
              root.onClickToggleNode(key)})
              elementClose("i")
            }
            elementOpen("a", null, null, "onclick", function ($event) {
              var $element = this;
            root.onClickTreeNode(key)})
              text("" + (key.name) + "")
              if (key.def.required) {
                elementOpen("span", "6cdb6bac-9548-4da3-ba22-685129261987_" + $key, hoisted3)
                  text(" *")
                elementClose("span")
              }
            elementClose("a")
            elementOpen("span", "ff6cfef7-91bb-4b2c-a273-393fc5ce498f_" + $key, hoisted4)
              text("" + (root.keyAsString(key)) + "")
            elementClose("span")
          elementClose("div")
          if (key.isNested) {
            elementOpen("div", null, null, "style", {display: isExpanded ? 'block' : 'none'})
              if (key.isNestedDocument) {
                description(key.def.keys, root)
              } else if (key.isNestedDocumentArray) {
                description(key.def.def.keys, root)
              }
            elementClose("div")
          }
        elementClose("li")
      }, this)
    }
  elementClose("ul")
}
